import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";

import { Send } from "lucide-react";
import YeulsButton from "../../yeuls-button";

const SendToMaskoreshetButton = ({ salary, onSend, disabled = false }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const isSent = !!salary?.is_sent_to_maskoreshet;
  const isDisabled = disabled || isSent || isLoading;

  const handleClick = async () => {
    if (isDisabled) {
      return;
    }

    setIsLoading(true);
    try {
      await onSend();
    } catch (error) {
      enqueueSnackbar(t("something-went-wrong"), { variant: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <YeulsButton
      variant="outlined"
      className={`salary-send-btn${isDisabled ? " is-disabled" : ""}`}
      disabled={isDisabled}
      loading={isLoading}
      onClick={handleClick}
    >
      <Send size={12} />
      &nbsp;
      {isSent ? t("sent-to-maskoreshet") : t("send-to-maskoreshet")}
    </YeulsButton>
  );
};

export default SendToMaskoreshetButton;
